import { connect } from 'react-redux';
import { ContentCard } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { refetchGroupAndShowSuccessFlash } from '../actions';

interface DispatchProps {
    onSuccess(): void;
}

interface OwnProps {
    refetchGroup(): void;
    reservationIds: string[];
    form: string;
}
interface FormCardFactory<TProps extends OwnProps> {
    FormElement: React.ComponentType<TProps & DispatchProps>;
    titleTextKey?: Mews.TextKey;
    onSuccessMessageKey?: Mews.TextKey;
    dataTestId?: string;
}

/**
 * @deprecated use <FormLayout />
 */
export const formCardFactory = <TProps extends OwnProps>({
    FormElement,
    titleTextKey,
    onSuccessMessageKey,
    dataTestId,
}: FormCardFactory<TProps>) => {
    const FormCardComponent: React.FC<DispatchProps> = (props) => (
        <ContentCard title={titleTextKey && <LocalizedText textKey={titleTextKey} />} data-test-form={dataTestId}>
            <FormElement {...(props as TProps & DispatchProps)} />
        </ContentCard>
    );

    return connect<{}, DispatchProps, TProps>(undefined, (_dispatch, { refetchGroup }) => ({
        onSuccess: () => refetchGroupAndShowSuccessFlash({ refetchGroup, messageKey: onSuccessMessageKey }),
    }))(FormCardComponent);
};
